export const formatDate = (value: string | Date) => {
  const today = new Date(value);

  const year = today.getFullYear();
  const month = `0${today.getMonth() + 1}`.slice(-2);
  const day = `0${today.getDate()}`.slice(-2);

  const dateString = `${year}년 ${month}월 ${day}일`;

  return dateString;
};

export const formatDateWithDot = (value: string | Date) => {
  const date = new Date(value);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}.${month}.${day}`;
};
